import { render, staticRenderFns } from "./AiAdviceListHeader.vue?vue&type=template&id=700a6293&scoped=true&"
import script from "./AiAdviceListHeader.vue?vue&type=script&lang=ts&"
export * from "./AiAdviceListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AiAdviceListHeader.vue?vue&type=style&index=0&id=700a6293&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a6293",
  null
  
)

export default component.exports